module.exports = __webpack_public_path__ + "img/activ8-logo-alpha-dark.05a33901.png";